export default __webpack_public_path__ + "static/media/washupReferralNewsBanner.1a461a70.png";